module.exports = __webpack_public_path__ + "img/bg.fe030f21.png";